import React, { useEffect, useState } from "react";
// interface
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import Loader from "components/Loader";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import LoadingIconWithText from "components/LoadingIconWithText";
import * as url from "../../../api/urls"
import { ucSetConfigValue } from "../../../redux/actions"

interface NotificationSettingProps {
  // basicDetails: BasicDetailsTypes;
}
const NotificationSetting = ({ /*basicDetails*/ }: NotificationSettingProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Settings,
    (st) => ({
      userConfig: st.userConfig,
      ucLoadUserConfigLoading: st.ucLoadUserConfigLoading,
    })
  );

  enum CONF {
    PUSH_FROM_CHAT = "PushFromChat",
    PUSH_FROM_WP = "PushFromWp"
  }

  const { ucLoadUserConfigLoading, userConfig } = useAppSelector(storeData);
  const [savingPushFromChat, setSavingPushFromChat] = useState<boolean>(false);
  const [savingPushFromWp, setSavingPushFromWp] = useState<boolean>(false);

  const setLoading = (configKey: string, loading: boolean) => {
    if (configKey == CONF.PUSH_FROM_CHAT) setSavingPushFromChat(loading);
    if (configKey == CONF.PUSH_FROM_WP) setSavingPushFromWp(loading);
  }

  const onUpdateConfig = async (configKey: string, configValue: boolean) => {
    try {
      setLoading(configKey, true);
      const api = new APIClient
      api.fnPostForm(url.UC_UPDATE_USER_CONFIG, { configKey: configKey, configValue: configValue ? "1" : "0" })
        .then(() => {
          setLoading(configKey, false);
          dispatch(ucSetConfigValue(configKey, configValue));
        })
        .catch((e) => {
          setLoading(configKey, false);
          Utils.HandleException(e, true);
        })
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }


  return (
    <div className="accordion-body " style={{ display: "flex", flexDirection: "column", gap: "20px", position: "relative" }}>
      {ucLoadUserConfigLoading && (<Loader></Loader>)}
      <div >
        <p className="text-primary mb-1">รับการเตือนแบบ PUSH จาก</p>
        <div className="d-flex justify-content-between align-items-center row">
          <div className="col">
            <input id="chk_push_chat" type="checkbox" checked={userConfig?.pushFromChat ?? true} onChange={(e) => onUpdateConfig(CONF.PUSH_FROM_CHAT, e.target.checked)}></input><label htmlFor="chk_push_chat">&nbsp;ระบบ Chat&nbsp;<i>(ยกเว้นชื่อถูก tag)</i></label>
            {savingPushFromChat && (<LoadingIconWithText loadingText={""} />)}
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center row">
          <div className="col">
            <input id="chk_push_wp" type="checkbox" checked={userConfig?.pushFromWp ?? true} onChange={(e) => onUpdateConfig(CONF.PUSH_FROM_WP, e.target.checked)}></input><label htmlFor="chk_push_wp">&nbsp;ระบบ Workplace</label>
            {savingPushFromWp && (<LoadingIconWithText loadingText={""} />)}
          </div>
        </div>

      </div>
    </div>
  );
};

export default NotificationSetting;
